import { render, staticRenderFns } from "./videoWalletHub.vue?vue&type=template&id=010e8f26&scoped=true"
import script from "./videoWalletHub.vue?vue&type=script&lang=js"
export * from "./videoWalletHub.vue?vue&type=script&lang=js"
import style0 from "./videoWalletHub.vue?vue&type=style&index=0&id=010e8f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e8f26",
  null
  
)

export default component.exports